import React, {Component} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class TitleHeader extends Component{
  constructor(props){
    super(props);
    this.state = {
        orderStatus : null,
        title : this.props.title,
        subtitle : this.props.subtitle,
        secondsubtitle: this.props.secondsubtitle
    }
  }

  render(){
    return(
        <div className="header-sample">
            <Container>
                <Row>
                    <Col xs={12} md={12}  className="text-align-left margin-auto">
                        <div className="font-size-lg bold">
                        {this.state.title}
                        </div>
                        <div  className="font-size-smd">
                          {this.state.subtitle}
                        </div>
                        <div className="font-size-smd">
                          {this.state.secondsubtitle}
                        </div>
                    </Col>
                 </Row>
              
             </Container>
        </div>
    )
    }
}
export default TitleHeader;